module.exports = __webpack_public_path__ + "img/logo.fe5c6dce.svg";